import React, { useCallback } from "react";
import { useQuery } from "@tanstack/react-query";
import { SearchDecorators } from "@graylog/server-api";
import { Spinner } from "components/common";
import AddDecoratorButton from "./AddDecoratorButton";
import DecoratorSummary from "./DecoratorSummary";
import DecoratorList from "./DecoratorList";
import DecoratorStyles from "./decoratorStyles.css";
const DecoratorSidebar = ({ decorators, onChange }) => {
  const { data: decoratorTypes } = useQuery({
    queryKey: ["decorators", "types"],
    queryFn: () => SearchDecorators.getAvailable()
  });
  const formatDecorator = useCallback(
    (decorator) => {
      const typeDefinition = decoratorTypes[decorator.type] || {
        requested_configuration: {},
        name: `Unknown type: ${decorator.type}`,
        type: decorator.type,
        human_name: decorator.type,
        link_to_docs: ""
      };
      const deleteDecorator = (decoratorId) => onChange(decorators.filter((_decorator) => _decorator.id !== decoratorId));
      const updateDecorator = (id, updatedDecorator) => onChange(decorators.map((_decorator) => _decorator.id === id ? updatedDecorator : _decorator));
      return {
        id: decorator.id,
        title: /* @__PURE__ */ React.createElement(
          DecoratorSummary,
          {
            key: `decorator-${decorator.id}`,
            decorator,
            decoratorTypes,
            onDelete: deleteDecorator,
            onUpdate: updateDecorator,
            typeDefinition
          }
        )
      };
    },
    [decoratorTypes, decorators, onChange]
  );
  const updateOrder = useCallback(
    (orderedDecorators) => {
      orderedDecorators.forEach((item, idx) => {
        const decorator = decorators.find((i) => i.id === item.id);
        decorator.order = idx;
      });
      onChange(decorators);
    },
    [decorators, onChange]
  );
  if (!decoratorTypes) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  const sortedDecorators = decorators.sort((d1, d2) => d1.order - d2.order);
  const nextDecoratorOrder = sortedDecorators.length > 0 ? sortedDecorators[sortedDecorators.length - 1].order + 1 : 0;
  const decoratorItems = sortedDecorators.map(formatDecorator);
  const addDecorator = (decorator) => onChange([...decorators, decorator]);
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(AddDecoratorButton, { decoratorTypes, nextOrder: nextDecoratorOrder, onCreate: addDecorator }), /* @__PURE__ */ React.createElement("div", { className: DecoratorStyles.decoratorListContainer }, /* @__PURE__ */ React.createElement(DecoratorList, { decorators: decoratorItems, onReorder: updateOrder })));
};
export default DecoratorSidebar;
